import { Button } from '@crazyegginc/hatch';

import { Modal } from '/src/contexts/modal';
import { WebP } from '/src/components/WebP';
import { UpsellWall } from '/src/components/UpsellWall';
import { AppLink } from '/src/features/_global/components/AppLink';
import { useManageSubscriptionPath } from '/src/hooks';

import FeaturedImagePNG from '@crazyegginc/hatch/dist/images/illustration-upsell-ctas.png';
import FeaturedImageWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-ctas.webp';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';

const TEXT_LIST = [
  {
    text: 'Stop cart abandonment in its tracks with special offers',
  },
  {
    text: 'Grow your email and SMS list - every contact is a potential sale',
  },
  {
    text: 'Get the word out on special offers, events, and product launches',
  },
];

export function CTAUpsellModal({ onBack }) {
  const manageSubscriptionPath = useManageSubscriptionPath();

  return (
    <Modal
      dialogClassName="!w-[640px] !px-2"
      dismissable={onBack ? false : true}
      disableOutsideClick={onBack ? true : false}
    >
      <div className="flex items-center">
        <div className="mx-4 flex items-center shrink-0">
          <WebP webp={FeaturedImageWebP} fallback={FeaturedImagePNG} width="230px" height="113px" alt="ctas feature" />
        </div>
        <div>
          <h2 className="text-header-1 font-semibold leading-tight">
            Don&apos;t let leads, subscribers, and buyers slip away
          </h2>
          <div className="text-body-2 my-6">
            Increase engagement with CTAs to highlight promotions, direct traffic to key pages, or grow your mailing
            list.
          </div>
          <UpsellWall.List list={TEXT_LIST} />
          <div className="w-full flex mt-1 space-x-2.5">
            {onBack ? (
              <Button variant="cancel" onClick={onBack}>
                <ArrowIcon className="mr-2 h-2.5 w-2.5 -rotate-90 fill-current" />
                Go Back
              </Button>
            ) : null}
            <Button component={AppLink} to={manageSubscriptionPath} target="_blank" rel="noopener noreferrer">
              View Plans
            </Button>
          </div>
        </div>
      </div>
      {onBack ? (
        <Button variant="cancel" onClick={onBack} className="absolute top-2 left-2">
          <ArrowIcon className="mr-2 h-2.5 w-2.5 -rotate-90 fill-current" />
          Back
        </Button>
      ) : null}
    </Modal>
  );
}
